import { takeLatest, call, put } from 'redux-saga/effects';
import get from 'lodash/get';
import filter from 'lodash/filter';
import { addItemToCart } from 'yoda-interfaces/lib/Cart/CartApi';
import itemCountUpdate from 'yoda-site-components/lib/actions/ItemCountAction';
import FactorySaga from './FactorySaga';
import loadingActions from '../actions/LoadingAction';
import addToCartActionTypes from '../actionTypes/AddToCartActionTypes';

const revieveOverlay = (revieveOverlayElement, zIndex) => {
    if (revieveOverlayElement) {
        revieveOverlayElement.style.zIndex = zIndex;
    }
};

function* RevieveAddToCartSaga(action) {
    const revieveOverlayElement = document.querySelector('#revieve-overlay');
    try {
        yield put(loadingActions.showLoader());
        revieveOverlay(revieveOverlayElement, '100');
        yield put({
            type: addToCartActionTypes.REVIEVE_ADDTOCART_RESET,
        });
        const addItemAction = {
            payload: {
                data: action.payload.data,
            },
            type: action.type,
        };
        const atcResponse = yield call(FactorySaga, addItemToCart, addItemAction);
        const getResponseCode = get(atcResponse, 'response.status', 200);
        if (getResponseCode === 200 || getResponseCode === 422) {
            yield put(loadingActions.removeLoader());
            revieveOverlay(revieveOverlayElement, '9999');
            const atcResponseData = get(atcResponse, 'response.data.data', []);
            const cartSuccessPayload = filter(atcResponseData, 'valid') || [];
            const cartFailurePayload = filter(atcResponseData, ['valid', false]) || [];
            yield put({
                type: addToCartActionTypes.REVIEVE_ADDTOCART_RESPONSE,
                cartSuccess: cartSuccessPayload,
                cartFailure: cartFailurePayload,
                totalAddToCartRequestCount: action.payload.data && action.payload.data.length,
            });

            if (getResponseCode === 200) {
                const { response } = atcResponse;
                const itemCount = response.headers.get('X-Item-Count');
                yield put(itemCountUpdate.updateItemCountAction(itemCount));
            }
        } else if (getResponseCode === 400) {
            const otherErrors = get(atcResponse, 'response.data[0]', []);
            yield put(loadingActions.removeLoader());
            revieveOverlay(revieveOverlayElement, '9999');
            yield put({
                type: addToCartActionTypes.REVIEVE_ADDTOCART_API_ERROR,
                cartSuccess: [],
                cartFailure: [],
                totalAddToCartRequestCount: action.payload.data && action.payload.data.length,
                otherErrors,
            });
        } else {
            const otherErrors = get(atcResponse, 'response.error', []);
            yield put(loadingActions.removeLoader());
            revieveOverlay(revieveOverlayElement, '9999');
            yield put({
                type: addToCartActionTypes.REVIEVE_ADDTOCART_API_ERROR,
                cartSuccess: [],
                cartFailure: [],
                totalAddToCartRequestCount: action.payload.data && action.payload.data.length,
                otherErrors,
            });
        }
    } catch (error) {
        const otherErrors = get(error, 'response.error', []);
        yield put(loadingActions.removeLoader());
        revieveOverlay(revieveOverlayElement, '9999');
        yield put({
            type: addToCartActionTypes.REVIEVE_ADDTOCART_API_ERROR,
            cartSuccess: [],
            cartFailure: [],
            totalAddToCartRequestCount: action.payload.data && action.payload.data.length,
            otherErrors,
        });
    }
}

const watchRevieveAddToCartSaga = function* watchAddToCartSaga() {
    yield takeLatest(addToCartActionTypes.REVIEVE_ADDTOCART_REQUEST, RevieveAddToCartSaga);
};

watchRevieveAddToCartSaga.sagaName = 'revieveAddToCartSaga';

export default watchRevieveAddToCartSaga;
